import { Injectable }       from '@angular/core';

import { InputDropdown } from './InputDropdown';
import { InputBase }     from './InputBase';
import { InputTextbox }  from './InputTextbox';

@Injectable()
export class InputService {

    public generateInputFieldsFromData(data:any){
        let inputFields: InputBase<any>[] = []; 
        for(let i=0; i < data.length;i++){
            let inputField;
            if(data[i].dataType === 'dropdown'){
                let optionList=[]
                let defaultValue = "";
                data[i].listItems.sort(this.sortListAlpha);
                data[i].listItems.sort(this.sortListByDisplayOrder);
                for(let x=0; x<data[i].listItems.length;x++){
                    optionList.push({key:data[i].listItems[x].itemValue, value:data[i].listItems[x].itemValue})
                    if(data[i].listItems[x].isDefault){
                        defaultValue =data[i].listItems[x].itemValue;
                    }
                }
                inputField = new InputDropdown({
                    key: data[i].fieldId,
                    label: data[i].dataPoint,
                    options: optionList //[]
                    ,value:defaultValue
                    ,required: data[i].isRequired
                })
            }else{
                inputField = new InputTextbox({
                    key: data[i].fieldId,
                    label: data[i].dataPoint,
                    value: data[i].defaultValue,
                    type:data[i].dataType,
                    required: data[i].isRequired
                })
            }
            inputFields.push(inputField);
        }
        return inputFields;
    }
    public generateInputSearchFieldsFromData(data:any){
        let inputFields: InputBase<any>[] = []; 
        for(let i=0; i < data.length;i++){
            let inputField;
            if(data[i].dataType === 'dropdown'){
                let optionList=[]
                let emptyValueFound:boolean = false;
                data[i].listItems.sort(this.sortListAlpha);
                data[i].listItems.sort(this.sortListByDisplayOrder);
                for(let x=0; x<data[i].listItems.length;x++){
                    if(data[i].listItems[x].itemValue.trim() !== ""){
                        optionList.push({key:data[i].listItems[x].itemValue, value:data[i].listItems[x].itemValue});
                    }
                }
                optionList.unshift({key:-1, value:""})
                
                inputField = new InputDropdown({
                    key: data[i].fieldId,
                    label: data[i].dataPoint + " (Equal)",
                    options: optionList
                    ,value:""
                    ,required: false
                })
            }else{
                let labelDeff:string = " (Equal)";
                if(data[i].dataType === "text"){
                    labelDeff = " (Like)"
                }
                inputField = new InputTextbox({
                    key: data[i].fieldId,
                    label: data[i].dataPoint + labelDeff,
                    value: '',
                    type:data[i].dataType,
                    required: false
                })
            }
            inputFields.push(inputField);
        }
        return inputFields;
    }

    private sortListAlpha(a:any,b:any){
        let la = a.itemValue.toLocaleLowerCase();
        let lb = b.itemValue.toLocaleLowerCase();
        if(la < lb){
            return -1;
        }else{
            return 1;
        };
    }
    private sortListByDisplayOrder(a:any,b:any){
        if(a.orderId<b.orderId){
            return -1;
        }else{
            return 1;
        };
    }
//   getQuestions() {

//     let questions: InputBase<any>[] = [
//         new InputTextbox({
//             key: 'idNumber',
//             label: 'ID Number',
//             value: '',
//             type:'text',
//             required: true,
//         }),
//         new InputTextbox({
//             key: 'horePower',
//             label: 'HP',
//             value: '',
//             type:'text',
//             required: true,
//         }),
//         new InputTextbox({
//             key: 'rpm',
//             label: 'RPM',
//             value: '',
//             type:'text',
//             required: true,
//         }),
//         new InputTextbox({
//             key: 'frame',
//             label: 'Frame',
//             value: '',
//             type:'text',
//             required: true,
//         }),

//         new InputTextbox({
//             key: 'brand',
//             label: 'Brand',
//             value: '',
//             type:'text',
//             required: true,
//         }),
//         new InputTextbox({
//             key: 'type',
//             label: 'Type',
//             value: '',
//             type:'text',
//             required: true,
//         }),
//         new InputDropdown({
//             key: 'buildType',
//             label: 'New / Rebuild',
//             options: [
//                 {key: 'New',  value: 'New'},
//                 {key: 'Rebuild',  value: 'Rebuild'},
//             ]
//         }),

//         new InputTextbox({
//             key: 'recDate',
//             label: 'Received Date',
//             value: '',
//             type:'date',
//             required: false,
//         }),
//         new InputTextbox({
//             key: 'from',
//             label: 'from',
//             value: '',
//             type:'text',
//             required: true,
//         }),

//         // new InputTextbox({
//         //     key: 'emailAddress',
//         //     label: 'Email',
//         //     type: 'email',
//         // })
//     ];

//     return questions;//.sort((a, b) => a.order - b.order);
//   }
}
